type AosLib = {
    init: (opts?: Record<string, unknown>) => void;
    refresh?: () => void;
};

export class AosInitializer {
    static init(): void {
        const aos = (window as unknown as { AOS?: AosLib }).AOS;
        if (!aos?.init) return;

        const reduceMotion =
            typeof window.matchMedia === "function" &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        if (reduceMotion) {
            aos.init({ disable: true });
            return;
        }

        aos.init();

        window.addEventListener(
            "load",
            () => {
                aos.refresh?.();
            },
            { once: true },
        );
    }
}
